import { createTheme, ThemeOptions } from "@mui/material"

const primary = {
  light: "#AB9579",
  main: "#1a2958",
  dark: "#051622",
}
// const secondary = {
//   light: "#DDDDDD",
//   main: "#333333",
//   dark: "#222222",
// };

const warning = {
  main: "#F8AC59",
  contrastText: "#fff",
}
const error = {
  main: "#F13B51",
}
// const info = {
//   main: secondary.main,
// };
const success = {
  main: "#31C47B",
  contrastText: "#fff",
}
const text = {
  primary: "#000000",
  secondary: "#1a2958",
  itemSubtitle: "#DDDDDD",
  warning: "red",
  success: "green",
}

export const theme: ThemeOptions = {
  palette: {
    primary,
    // secondary,

    background: {
      default: "#fff",
    },
    error,
    warning,
    // info,
    success,
    text,
    default: {
      main: text.primary,
      contrastText: "#fff",
    },
  },
  typography: {
    // fontFamily: "Lato, sans-serif",
    fontFamily: "Helvetica",
    h1: {
      fontSize: "1.75rem", // 20px
      fontWeight: 700, // bold
      fontFamily: "Unbounded, sans-serif",
    },
    h2: {
      fontSize: "1.25rem", // 20px
      fontWeight: 700, // semi-bold
    },
    h3: {
      fontSize: "1.125rem", // 18px
      fontWeight: 700, // bold
    },
    h4: {
      fontSize: "1rem", // 18px
      fontWeight: 600, // semi-bold
    },
    h5: {
      fontSize: ".9rem", // 16px
      fontWeight: 600, // bold
      lineHeight: "94%",
    },
    h6: {
      fontSize: ".75rem", // 16px
      fontWeight: 550, // semi-bold
      lineHeight: "94%",
    },
    body1: {
      fontSize: "1rem", // 16px
      fontWeight: 400, // regular
      lineHeight: "94%",
    },
    body2: {
      fontSize: "0.875rem", // 14px
      fontWeight: 400, // regular
      lineHeight: "94%",
    },
    subtitle1: {
      fontSize: "1.5rem",
      fontFamily: "Unbounded, sans-serif",
    },
    subtitle2: {
      fontSize: "0.875rem", // 14px
      fontWeight: 500, // medium
      fontFamily: "Unbounded, sans-serif",
    },
    button: {
      fontWeight: 600,
      textTransform: "none",
    },
    caption: {
      fontSize: "0.75rem", // 12px
    },
  },
  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          "&::before, &::after": {
            borderColor: "primary.dark",
          },
        },
      },
    },
  },
}

declare module "@mui/material/styles" {
  interface Palette {
    default: Palette["primary"]
    // gradient: {};
  }
  interface PaletteOptions {
    default?: PaletteOptions["primary"]
  }
}

const themeInstance = createTheme(theme)

export default themeInstance
